import { default as Axis } from "./Axis";
/**
    @class AxisLeft
    @extends Axis
    @desc Shorthand method for creating an axis where the ticks are drawn to the left of the vertical domain path. Extends all functionality of the base [Axis](#Axis) class.
*/

var AxisLeft =
/*@__PURE__*/
function (Axis) {
  function AxisLeft() {
    Axis.call(this);
    this.orient("left");
  }

  if (Axis) AxisLeft.__proto__ = Axis;
  AxisLeft.prototype = Object.create(Axis && Axis.prototype);
  AxisLeft.prototype.constructor = AxisLeft;
  return AxisLeft;
}(Axis);

export default AxisLeft;